import { LocationLevel } from '../../application/entities/location-level.entity';
import { LocationLevelsResponseDto } from '../dto/location-levels-response.dto';

export function toLocationLevels(dto: LocationLevelsResponseDto): LocationLevel[] {
  return (dto.data.levels ?? [])
    .map((l) => ({
      displayOrder: l.displayOrder,
      levelName: l.levelName,
      levelUuid: l.levelUuid ?? null,
      parentLevelUuid: l.parentLevelUuid ?? null,
      locations: (l.locations ?? []).map((loc) => ({
        uuid: loc.uuid,
        name: loc.name,
        parentUuid: loc.parentUuid ?? null,
        levelUuid: loc.levelUuid ?? null,
      })),
    }))
    .sort((a, b) => a.displayOrder - b.displayOrder);
}
